import { SEARCH_PAGE } from 'constants/amethystPageTypes';
import { SEARCH_FEEDBACK_CLICK } from 'constants/reduxActions';
import { HYDRA_RET } from 'constants/hydraTests';

import { isAssigned } from 'actions/ab';
import { middlewareTrack } from 'apis/amethyst';
import { getAmethystPageType, trackEvent } from 'helpers/analytics';
import {
  CLOSE_LA,
  LOGIN_FROM_LA,
  SHOW_LA
} from 'store/ducks/loginAssistant/types';
import {
  STORE_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM
} from 'store/ducks/rewards/types';

/*
  Global Events:
  This will allow you to fire events based on client-side actions across the site
*/

const EVENT_CART_MODAL_VIEW = 'EVENT_CART_MODAL_VIEW';

export const cartModalViewEvent = () => ({
  type: EVENT_CART_MODAL_VIEW
});

/**
  * https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SentimentFeedback.proto
  *
  * @param {boolean} feedback - Customer input on whether search results were helpful -> this comes from the 'feedback' payload from the Redux action
*/
const evFeedbackClick = (_, { feedback }) => {
  middlewareTrack({
    sentimentFeedback: {
      pageType: SEARCH_PAGE,
      feedbackType: 'SEARCH_RELEVANCY_FEEDBACK',
      positive: feedback,
      negative: !feedback
    }
  });
};

const teOnCloseLoginAssistantClick = () => trackEvent('TE_CLOSE_LA');
const teOnLoginFromLoginAssistantClick = () => trackEvent('TE_LOGIN_FROM_LA');
const teOnShowLoginAssistant = () => trackEvent('TE_SHOW_LA');

const evOnShowRewardsTransparencyPdp = appState => {
  const { cookies: { 'x-main': xMain }, pageView: { pageType }, sharedRewards: { transparencyPointsForItem, isEnrolled } } = appState;
  const isInTransparencyTest = isAssigned(HYDRA_RET, 1, appState);

  if (isInTransparencyTest && transparencyPointsForItem) {

    // ZFC event
    const recognizedStatus = xMain ? 'recognized' : 'unrecognized';
    const enrolledStatus = isEnrolled ? 'enrolled' : 'unenrolled';
    trackEvent('TE_SHOW_REWARDS_TRANSPARENCY', `${pageType}:${transparencyPointsForItem}:${recognizedStatus}:${enrolledStatus}`);

    // Amethyst event
    middlewareTrack({
      rewardsTransparencyImpression: {
        sourcePage: getAmethystPageType(pageType),
        isEnrolled: !!isEnrolled,
        rewardsPoints: transparencyPointsForItem
      }
    });
  }
};

const evOnShowRewardsTransparencyCartModal = appState => {
  const { cookies: { 'x-main': xMain }, sharedRewards: { transparencyPointsForCart, isEnrolled } } = appState;
  const isInTransparencyTest = isAssigned(HYDRA_RET, 1, appState);

  if (isInTransparencyTest && transparencyPointsForCart) {

    // ZFC event
    const recognizedStatus = xMain ? 'recognized' : 'unrecognized';
    const enrolledStatus = isEnrolled ? 'enrolled' : 'unenrolled';
    trackEvent('TE_SHOW_REWARDS_TRANSPARENCY', `cartModal:${transparencyPointsForCart}:${recognizedStatus}:${enrolledStatus}}`);

    // Amethyst event
    middlewareTrack({
      rewardsTransparencyImpression: {
        sourcePage: 'CART_PAGE_MODAL',
        isEnrolled: !!isEnrolled,
        rewardsPoints: transparencyPointsForCart
      }
    });
  }
};

export const evOnShowRewardsTransparencyClick = ({ isForCartModal, pageType, rewards, pointsForCurrentPage, isRecognizedCustomer }) => {
  const { isEnrolled, transparencyPointsForCart } = rewards;
  const recognizedStatus = isRecognizedCustomer ? 'recognized' : 'unrecognized';
  const rewardsPoints = isForCartModal ? transparencyPointsForCart : pointsForCurrentPage;
  const enrolledStatus = isEnrolled ? 'enrolled' : 'unenrolled';
  const view = isForCartModal ? 'cartModal' : pageType;

  trackEvent('TE_CLICK_REWARDS_TRANSPARENCY', `${view}:${rewardsPoints}:${recognizedStatus}:${enrolledStatus}`);

  return {
    rewardsTransparencyClick: {
      sourcePage: getAmethystPageType(pageType),
      isEnrolled: !!isEnrolled,
      rewardsPoints
    }
  };
};

export default {
  events: {
    [SEARCH_FEEDBACK_CLICK]: [evFeedbackClick],
    [CLOSE_LA]: [teOnCloseLoginAssistantClick],
    [LOGIN_FROM_LA]: [teOnLoginFromLoginAssistantClick],
    [SHOW_LA]: [teOnShowLoginAssistant],
    [STORE_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM]: [evOnShowRewardsTransparencyPdp],
    [EVENT_CART_MODAL_VIEW]: [evOnShowRewardsTransparencyCartModal]
  }
};
